export const wideNavQuery = window.matchMedia("(min-width: 58.8125em) and (min-height: 24em)");
export const supportsAnimationQuery = window.matchMedia("(prefers-reduced-motion: no-preference)");